import { createAuthenticatedApiClient } from '../../../shared/api/apiClient';
import { rpcCall } from '../../../shared/api/rpcClient';
import { useAuth } from '../../auth/context/AuthContext';
import { useMemo } from 'react';
import type { ContactWithUser } from '../../../types';

export const createContactService = (idToken: string) => {
  const client = createAuthenticatedApiClient(idToken);

  return {
    listContacts: async (customerId: string): Promise<ContactWithUser[]> => {
      return rpcCall<ContactWithUser[]>(client, 'customers.ListContacts', { customer_id: customerId });
    },

    updateContactMetadata: async (
      customerId: string,
      username: string,
      update: { contact_types?: string[]; role?: string },
    ): Promise<void> => {
      return rpcCall<void>(client, 'customers.UpdateContactMetadata', {
        customer_id: customerId,
        username,
        ...update,
      });
    },

    reorderOperationalContacts: async (customerId: string, orderedUsernames: string[]): Promise<void> => {
      return rpcCall<void>(client, 'customers.ReorderOperationalContacts', {
        customer_id: customerId,
        ordered_usernames: orderedUsernames,
      });
    },

    updateCustomerContactTypes: async (customerId: string, contactTypes: string[]): Promise<void> => {
      return rpcCall<void>(client, 'customers.UpdateCustomerContactTypes', {
        customer_id: customerId,
        contact_types: contactTypes,
      });
    },
  };
};

export const useContactService = () => {
  const { idToken } = useAuth();

  return useMemo(() => {
    if (!idToken) {
      throw new Error('Not authenticated');
    }

    return createContactService(idToken);
  }, [idToken]);
};
